import PropTypes from "prop-types";
import React from "react";
/**
 * @typedef {object} SpinWhenEmptyProps
 * @property {any} [children]
 */

/**
 * @type {React.FC<SpinWhenEmptyProps & { [key: string]: any }>}
 */

export const SpinWhenEmpty = ({
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "spin-when-empty"
}, children);
SpinWhenEmpty.propTypes = {
  children: PropTypes.any
};